import React, { useEffect, useState } from "react";
import "./whychooseus.css";
import axios from "axios";
function WhyChooseNew() {

  const [ChooseUs, setChooseUs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_choose_us"
      );
      setChooseUs(response.data.data);
    };

    fetchData();
  }, []);

  return (
    <>
      <section className="choose-us-section">
        {ChooseUs.filter((Data) => Data.us_id === "1").map(
          (Data, index) => {
            return (
              <div className="container">
                <div className="row" key={index}>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12 choose-col">
                    <div className="why_us_wrapper">
                      <figure className="mb-0 whyus_img">
                        <img src={`https://cyberathon.com/NLF/${Data.us_image}`} alt="" />
                      </figure>
                      <figure className="mb-0 whyus-dot">
                        <img
                          src="../about-us-img/about-us-dot.png"
                          alt=""
                          className="img-fluid"
                        />
                      </figure>

                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-2 choose-col">
                    <div className="whyus_content aos-init" data-aos="fade-right">
                      <h2>Why Choose Us..<b>.?</b></h2>
                      <p>{Data.us_heading}</p>
                      <p>
                        <div dangerouslySetInnerHTML={{ __html: Data.us_description }}></div>
                      </p>
                      {/* <Link to="/about-us"
                  className="read_more text-white text-decoration-none">
                  Read More                 
                    <i className="arrow fa-solid fa-arrow-right" style={{color: '#ffffff', position: 'relative', right: '10px', top: '2px'}}></i>
                  
                  
                </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        )}


        {/* <figure className="mb-0 about-rightcircle">
          <img
            src="about-img/about-us-rightcircle.png"
            alt=""
            className="img-fluid"
          />
        </figure> */}
      </section>
    </>
  );
}

export default WhyChooseNew;
